<div class="app-sidebar bb-sidebar">
  <div class="scrollbar-sidebar">
    <div class="app-sidebar__inner bb-sidebar-inner">

      <nav class="sb-nav">

        <!-- Dashboard — standalone, no group -->
        <a class="sb-nav-item" [class.active]="isRouteActive('/dashboard')"
           href="javascript:void(0);" (click)="goToPage('/dashboard')"
           (contextmenu)="onMenuRightClick($event, '/dashboard')">
          <i class="pe-7s-rocket"></i>
          <span>Dashboard</span>
        </a>

        <!-- Issue / Receive — top-level shortcut for runners -->
        <a *ngIf="isManager()" class="sb-nav-item" [class.active]="isRouteActive('/issue-receive')"
           href="javascript:void(0);" (click)="goToPage('/issue-receive')"
           (contextmenu)="onMenuRightClick($event, '/issue-receive')">
          <i class="pe-7s-refresh-2"></i>
          <span>Issue / Receive Books</span>
        </a>

        <!-- ── Library ──────────────────────────────────────────── -->
        <div class="sb-group">
          <div class="sb-group-header"
               [class.open]="openGroup === 'library'"
               [class.has-active]="isGroupHasActive('library')"
               (click)="toggleGroup('library')">
            <i class="pe-7s-bookmarks"></i>
            <span>Library</span>
            <i class="pe-7s-angle-right sb-chevron"></i>
          </div>
          <div class="sb-group-content" [class.open]="openGroup === 'library'">
            <a class="sb-sub-item" [class.active]="isRouteActive('/add-book')"
               href="javascript:void(0);" (click)="goToPage('/add-book')"
               (contextmenu)="onMenuRightClick($event, '/add-book')">
              <i class="pe-7s-notebook"></i><span>Add Book</span>
            </a>
            <a class="sb-sub-item" [class.active]="isRouteActive('/books')"
               href="javascript:void(0);" (click)="goToPage('/books')"
               (contextmenu)="onMenuRightClick($event, '/books')">
              <i class="pe-7s-bookmarks"></i><span>Book Master</span>
            </a>
            <a class="sb-sub-item" [class.active]="isRouteActive('/authors')"
               href="javascript:void(0);" (click)="goToPage('/authors')"
               (contextmenu)="onMenuRightClick($event, '/authors')">
              <i class="pe-7s-pen"></i><span>Author Master</span>
            </a>
            <a class="sb-sub-item" [class.active]="isRouteActive('/categories')"
               href="javascript:void(0);" (click)="goToPage('/categories')"
               (contextmenu)="onMenuRightClick($event, '/categories')">
              <i class="pe-7s-folder"></i><span>Category Master</span>
            </a>
            <a class="sb-sub-item" [class.active]="isRouteActive('/languages')"
               href="javascript:void(0);" (click)="goToPage('/languages')"
               (contextmenu)="onMenuRightClick($event, '/languages')">
              <i class="pe-7s-global"></i><span>Language Master</span>
            </a>
            <a class="sb-sub-item" [class.active]="isRouteActive('/book-inventory')"
               href="javascript:void(0);" (click)="goToPage('/book-inventory')"
               (contextmenu)="onMenuRightClick($event, '/book-inventory')">
              <i class="pe-7s-box2"></i><span>Book Inventory</span>
            </a>
            <a *ngIf="isManagerOrAdmin()" class="sb-sub-item" [class.active]="isRouteActive('/book-locator')"
               href="javascript:void(0);" (click)="goToPage('/book-locator')"
               (contextmenu)="onMenuRightClick($event, '/book-locator')">
              <i class="pe-7s-map-marker"></i><span>Book Locator</span>
            </a>
            <a class="sb-sub-item" [class.active]="isRouteActive('/search-by-author')"
               href="javascript:void(0);" (click)="goToPage('/search-by-author')"
               (contextmenu)="onMenuRightClick($event, '/search-by-author')">
              <i class="pe-7s-pen"></i><span>Search by Author</span>
            </a>
            <a class="sb-sub-item" [class.active]="isRouteActive('/search-by-category')"
               href="javascript:void(0);" (click)="goToPage('/search-by-category')"
               (contextmenu)="onMenuRightClick($event, '/search-by-category')">
              <i class="pe-7s-folder"></i><span>Search by Category</span>
            </a>
            <a class="sb-sub-item" [class.active]="isRouteActive('/book-catalogue')"
               href="javascript:void(0);" (click)="goToPage('/book-catalogue')"
               (contextmenu)="onMenuRightClick($event, '/book-catalogue')">
              <i class="pe-7s-file"></i><span>Book Catalogue PDF</span>
            </a>
          </div>
        </div>

        <!-- ── Operations (Manager / Admin) ────────────────────── -->
        <div class="sb-group" *ngIf="isManagerOrAdmin()">
          <div class="sb-group-header"
               [class.open]="openGroup === 'operations'"
               [class.has-active]="isGroupHasActive('operations')"
               (click)="toggleGroup('operations')">
            <i class="pe-7s-refresh-2"></i>
            <span>Operations</span>
            <i class="pe-7s-angle-right sb-chevron"></i>
          </div>
          <div class="sb-group-content" [class.open]="openGroup === 'operations'">
            <a class="sb-sub-item" [class.active]="isRouteActive('/issue-receive')"
               href="javascript:void(0);" (click)="goToPage('/issue-receive')"
               (contextmenu)="onMenuRightClick($event, '/issue-receive')">
              <i class="pe-7s-refresh-2"></i><span>Issue / Receive Books</span>
            </a>
            <a class="sb-sub-item" [class.active]="isRouteActive('/barcode-labels')"
               href="javascript:void(0);" (click)="goToPage('/barcode-labels')"
               (contextmenu)="onMenuRightClick($event, '/barcode-labels')">
              <i class="pe-7s-print"></i><span>Print Barcode Labels</span>
            </a>
            <a class="sb-sub-item" [class.active]="isRouteActive('/book-claims')"
               href="javascript:void(0);" (click)="goToPage('/book-claims')"
               (contextmenu)="onMenuRightClick($event, '/book-claims')">
              <i class="pe-7s-pin"></i><span>Book Claims</span>
            </a>
            <a class="sb-sub-item" [class.active]="isRouteActive('/inter-center-transfer')"
               href="javascript:void(0);" (click)="goToPage('/inter-center-transfer')"
               (contextmenu)="onMenuRightClick($event, '/inter-center-transfer')">
              <i class="pe-7s-shuffle"></i><span>Inter-Center Transfer</span>
            </a>
            <a class="sb-sub-item" *ngIf="isManager()" [class.active]="isRouteActive('/add-member')"
               href="javascript:void(0);" (click)="goToPage('/add-member')"
               (contextmenu)="onMenuRightClick($event, '/add-member')">
              <i class="pe-7s-user"></i><span>Add New Member</span>
            </a>
            <a class="sb-sub-item" *ngIf="isManager()" [class.active]="isRouteActive('/members')"
               href="javascript:void(0);" (click)="goToPage('/members')"
               (contextmenu)="onMenuRightClick($event, '/members')">
              <i class="pe-7s-users"></i><span>Member Master</span>
            </a>
          </div>
        </div>

        <!-- ── Management (Admin only) ──────────────────────────── -->
        <div class="sb-group" *ngIf="isAdmin()">
          <div class="sb-group-header"
               [class.open]="openGroup === 'management'"
               [class.has-active]="isGroupHasActive('management')"
               (click)="toggleGroup('management')">
            <i class="pe-7s-settings"></i>
            <span>Management</span>
            <i class="pe-7s-angle-right sb-chevron"></i>
          </div>
          <div class="sb-group-content" [class.open]="openGroup === 'management'">
            <a class="sb-sub-item" [class.active]="isRouteActive('/add-member')"
               href="javascript:void(0);" (click)="goToPage('/add-member')"
               (contextmenu)="onMenuRightClick($event, '/add-member')">
              <i class="pe-7s-user"></i><span>Add New Member</span>
            </a>
            <a class="sb-sub-item" [class.active]="isRouteActive('/members')"
               href="javascript:void(0);" (click)="goToPage('/members')"
               (contextmenu)="onMenuRightClick($event, '/members')">
              <i class="pe-7s-users"></i><span>Member Master</span>
            </a>
            <a class="sb-sub-item" [class.active]="isRouteActive('/users')"
               href="javascript:void(0);" (click)="goToPage('/users')"
               (contextmenu)="onMenuRightClick($event, '/users')">
              <i class="pe-7s-id"></i><span>User Master</span>
            </a>
            <a class="sb-sub-item" [class.active]="isRouteActive('/routes')"
               href="javascript:void(0);" (click)="goToPage('/routes')"
               (contextmenu)="onMenuRightClick($event, '/routes')">
              <i class="pe-7s-map"></i><span>Route Master</span>
            </a>
            <a class="sb-sub-item" [class.active]="isRouteActive('/centers')"
               href="javascript:void(0);" (click)="goToPage('/centers')"
               (contextmenu)="onMenuRightClick($event, '/centers')">
              <i class="pe-7s-home"></i><span>Center Master</span>
            </a>
            <a class="sb-sub-item" [class.active]="isRouteActive('/closure-reasons')"
               href="javascript:void(0);" (click)="goToPage('/closure-reasons')"
               (contextmenu)="onMenuRightClick($event, '/closure-reasons')">
              <i class="pe-7s-lock"></i><span>Closure Reasons</span>
            </a>
          </div>
        </div>

        <!-- ── Reports ─────────────────────────────────────────── -->
        <div class="sb-group">
          <div class="sb-group-header"
               [class.open]="openGroup === 'reports'"
               [class.has-active]="isGroupHasActive('reports')"
               (click)="toggleGroup('reports')">
            <i class="pe-7s-graph1"></i>
            <span>Reports</span>
            <i class="pe-7s-angle-right sb-chevron"></i>
          </div>
          <div class="sb-group-content" [class.open]="openGroup === 'reports'">
            <a class="sb-sub-item" [class.active]="isRouteActive('/reports/book-exchange')"
               href="javascript:void(0);" (click)="goToPage('/reports/book-exchange')"
               (contextmenu)="onMenuRightClick($event, '/reports/book-exchange')">
              <i class="pe-7s-graph1"></i><span>Book Exchange History</span>
            </a>
            <a *ngIf="isManagerOrAdmin()" class="sb-sub-item" [class.active]="isRouteActive('/reports/receipt-payment')"
               href="javascript:void(0);" (click)="goToPage('/reports/receipt-payment')"
               (contextmenu)="onMenuRightClick($event, '/reports/receipt-payment')">
              <i class="pe-7s-cash"></i><span>Receipt / Payment</span>
            </a>
            <a *ngIf="isManagerOrAdmin()" class="sb-sub-item" [class.active]="isRouteActive('/reports/closed-members')"
               href="javascript:void(0);" (click)="goToPage('/reports/closed-members')"
               (contextmenu)="onMenuRightClick($event, '/reports/closed-members')">
              <i class="pe-7s-lock"></i><span>Closed Members</span>
            </a>
            <a *ngIf="isManagerOrAdmin()" class="sb-sub-item" [class.active]="isRouteActive('/daily-summary')"
               href="javascript:void(0);" (click)="goToPage('/daily-summary')"
               (contextmenu)="onMenuRightClick($event, '/daily-summary')">
              <i class="pe-7s-date"></i><span>Daily Summary</span>
            </a>
          </div>
        </div>

        <!-- ── Configuration (Admin only) ──────────────────────── -->
        <div class="sb-group" *ngIf="isAdmin()">
          <div class="sb-group-header"
               [class.open]="openGroup === 'configuration'"
               [class.has-active]="isGroupHasActive('configuration')"
               (click)="toggleGroup('configuration')">
            <i class="pe-7s-config"></i>
            <span>Configuration</span>
            <i class="pe-7s-angle-right sb-chevron"></i>
          </div>
          <div class="sb-group-content" [class.open]="openGroup === 'configuration'">
            <a class="sb-sub-item" [class.active]="isRouteActive('/settings')"
               href="javascript:void(0);" (click)="goToPage('/settings')"
               (contextmenu)="onMenuRightClick($event, '/settings')">
              <i class="pe-7s-config"></i><span>Settings</span>
            </a>
            <a class="sb-sub-item" [class.active]="isRouteActive('/label-config')"
               href="javascript:void(0);" (click)="goToPage('/label-config')"
               (contextmenu)="onMenuRightClick($event, '/label-config')">
              <i class="pe-7s-print"></i><span>Label Settings</span>
            </a>
          </div>
        </div>

      </nav>

      <!-- User Footer -->
      <div class="sb-footer">
        <div class="sb-user">
          <div class="sb-avatar">{{ userInitial }}</div>
          <div class="sb-user-info">
            <div class="sb-user-name">{{ userName }}</div>
            <div class="sb-user-role">{{ userRole }}</div>
          </div>
        </div>
        <button class="sb-chpwd" (click)="openCpModal()" title="Change Password">
          <i class="pe-7s-lock"></i>
        </button>
        <button class="sb-logout" (click)="logout()" title="Sign Out">
          <i class="pe-7s-power"></i>
        </button>
      </div>

    </div>
  </div>
</div>

<!-- ── Change Password Modal ──────────────────────────────────────────────── -->
<div *ngIf="showCpModal" class="cp-overlay" (click)="closeCpModal()">
  <div class="cp-modal" (click)="$event.stopPropagation()">

    <div class="cp-header">
      <span><i class="pe-7s-lock me-2"></i>Change Password</span>
      <button class="cp-close" (click)="closeCpModal()">&#x2715;</button>
    </div>

    <div class="cp-body">

      <!-- Current password -->
      <div class="cp-field">
        <label class="cp-label">Current Password</label>
        <div class="cp-input-wrap">
          <input [type]="showCpCurrent ? 'text' : 'password'" [(ngModel)]="cpCurrent"
                 class="form-control form-control-sm" placeholder="Enter current password" />
          <button type="button" class="cp-eye" (click)="showCpCurrent = !showCpCurrent" tabindex="-1">
            <i [class]="showCpCurrent ? 'pe-7s-close-circle' : 'pe-7s-look'"></i>
          </button>
        </div>
      </div>

      <!-- New password -->
      <div class="cp-field">
        <label class="cp-label">New Password</label>
        <div class="cp-input-wrap">
          <input [type]="showCpNew ? 'text' : 'password'" [(ngModel)]="cpNew"
                 class="form-control form-control-sm" placeholder="Enter new password" />
          <button type="button" class="cp-eye" (click)="showCpNew = !showCpNew" tabindex="-1">
            <i [class]="showCpNew ? 'pe-7s-close-circle' : 'pe-7s-look'"></i>
          </button>
        </div>
        <div class="pw-rules mt-2">
          <div class="pw-rule" [class.pw-rule--met]="cpHas8">Minimum 8 characters</div>
          <div class="pw-rule" [class.pw-rule--met]="cpHasUpper">At least 1 uppercase letter (A–Z)</div>
          <div class="pw-rule" [class.pw-rule--met]="cpHasLower">At least 1 lowercase letter (a–z)</div>
          <div class="pw-rule" [class.pw-rule--met]="cpHasNumber">At least 1 number (0–9)</div>
          <div class="pw-rule" [class.pw-rule--met]="cpHasSpecial">At least 1 special character (@, $, !, %)</div>
        </div>
      </div>

      <!-- Confirm new password -->
      <div class="cp-field">
        <label class="cp-label">Confirm New Password</label>
        <div class="cp-input-wrap">
          <input [type]="showCpConfirm ? 'text' : 'password'" [(ngModel)]="cpConfirm"
                 class="form-control form-control-sm" placeholder="Re-enter new password" />
          <button type="button" class="cp-eye" (click)="showCpConfirm = !showCpConfirm" tabindex="-1">
            <i [class]="showCpConfirm ? 'pe-7s-close-circle' : 'pe-7s-look'"></i>
          </button>
        </div>
        <div class="cp-mismatch" *ngIf="cpConfirm && cpNew !== cpConfirm">
          Passwords do not match.
        </div>
      </div>

      <div class="cp-error"   *ngIf="cpError">{{ cpError }}</div>
      <div class="cp-success" *ngIf="cpSuccess">{{ cpSuccess }}</div>

    </div>

    <div class="cp-footer">
      <button class="cp-btn cp-btn--cancel" (click)="closeCpModal()">Cancel</button>
      <button class="cp-btn cp-btn--save" (click)="submitCpModal()" [disabled]="!cpIsValid || cpSaving">
        <span *ngIf="!cpSaving">Change Password</span>
        <span *ngIf="cpSaving" class="d-flex align-items-center gap-1">
          <span class="spinner-border spinner-border-sm"></span> Saving...
        </span>
      </button>
    </div>

  </div>
</div>

<!-- ── Quick Access context menu ──────────────────────────────────────────── -->
<div *ngIf="ctxMenu.visible"
     class="sb-ctx-menu"
     [style.left.px]="ctxMenu.x"
     [style.top.px]="ctxMenu.y"
     (click)="$event.stopPropagation()">

  <ng-container *ngIf="qa.isPinned(ctxMenu.route)">
    <div class="sb-ctx-item sb-ctx-remove" (click)="unpinRoute(ctxMenu.route)">
      <i class="pe-7s-close-circle me-1"></i> Remove from Quick Access
    </div>
  </ng-container>

  <ng-container *ngIf="!qa.isPinned(ctxMenu.route)">
    <div class="sb-ctx-item" *ngIf="qa.canPin()" (click)="pinRoute(ctxMenu.route)">
      <i class="pe-7s-star me-1"></i> Add to Quick Access
    </div>
    <div class="sb-ctx-item sb-ctx-disabled" *ngIf="!qa.canPin()">
      <i class="pe-7s-star me-1"></i> Quick Access full (5/5)
    </div>
  </ng-container>

</div>
